import axios from 'axios';
import LoadIndicator from 'devextreme-react/load-indicator';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { backendlink } from '../../config';
import { useAuth } from '../../contexts/auth';
import './DoctorPatientInfoList.css';
// import {
//     SciChartSurface,
//     NumericAxis,
//     PieSegment,
//     SciChartPieSurface,
//     EPieType,
//     XyDataSeries,
//     FastLineRenderableSeries,
//     EAutoRange,
//     ENumericFormat,
//     EAxisAlignment,
//     LegendModifier,
//     NumberRange,
//     DateTimeNumericAxis,
//     CategoryAxis,
//     TextLabelProvider,
//     RolloverModifier,
//     ELabelProviderType,
//     CursorModifier,
//     SciChartJSLightTheme,
//     SciChartJsNavyTheme
// } from "scichart";
import * as d3 from 'd3';

export default function DoctorPatientInfoList({ fetchTrigger }) {
    const { user } = useAuth();

    const navigate = useNavigate();

    const [users, setUsers] = useState([]);
    const [patient, setPatient] = useState([]);
    const [patientToken, setPatientToken] = useState("")
    const [selectedDuration, setSelectedDuration] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleDurationChange = (event) => {
        setSelectedDuration(event.target.value);
    };

    const location = useLocation();

    // const [loading, setLoading] = useState(false);
    const [formData, setformData] = useState({ name: '', linkedCustomerToken: '', linkedCustomerName: '', address: '', contactPerson: '', email: '', phone: '', countryCode: '', phoneForOtp: '', loginEmail: '', status: '' });
    const formDataRef = useRef(null)

    const [BPTable, setBPTable] = useState({
        mean_systolic_blood_pressure: 0,
        min_systolic_blood_pressure: 0,
        max_systolic_blood_pressure: 0,
        mean_diastolic_blood_pressure: 0,
        min_diastolic_blood_pressure: 0,
        max_diastolic_blood_pressure: 0,
        mean_pulse: 0,
        min_pulse: 0,
        max_pulse: 0,
    });
    const [BPPieChart, setBPPieChart] = useState({
        mean_pulse: 0,
        min_pulse: 0,
        max_pulse: 0,
    });

    const [BPGraph, setBPGraph] = useState();

    const [additionalAttributes, setAdditionalAttributes] = useState([]);

    const getPatientAttribute = async (organizationToken) => {
        try {
            const response = await axios.get(
                backendlink + "doctor/getpatientattribute",
                {
                    params: {
                        organizationToken: organizationToken,
                        userToken: location.state.patientToken,
                    },
                    headers: {
                        token: user.token,
                    },
                }
            );

            if (
                response?.data?.errorno === 0 &&
                response?.data?.result?.length > 0
            ) {
                const mappedAttributes = response?.data?.result?.map((attribute) => {
                    return {
                        label: attribute.name,
                        value: attribute.value,
                        dataField: attribute.code,
                    };
                });

                setAdditionalAttributes(mappedAttributes);
            } else {
                console.log(response?.data?.errmessage);
            }
        } catch (error) {
            console.error(error);
        }
    };

    function pressEdit() {
        navigate('/doctor-patient-edit', { state: { patientToken: patientToken } });
    }

    function pressChangePassword() {
        navigate('/doctor-patient-changepassword', { state: { patientToken: patientToken } });
    }

    function pressLog() {
        navigate('/doctor-patient-log', { state: { patientToken: patientToken } });
    }

    function pressMessage() {
        navigate('/doctor-patient-message', { state: { patientToken: patientToken } });
    }


    useEffect(() => {
        if (location.state?.patientToken == null) {
            navigate('/');
        } else {
            setPatientToken(location.state.patientToken);

            const fetchData = async () => {
                try {
                    const response = await axios.post(backendlink + 'doctor/getpatient',
                        {
                            doctortoken: user.userToken,
                            patienttoken: location.state.patientToken
                        },
                        {
                            headers: {
                                token: user.token
                            }
                        });

                    if (response.data.errorno == 0) {
                        const outputArray = response.data.result.map(item => {
                            var statusString = (item.isEnabled == true ? 'Active' : 'Inactive')
                            var countryCodeString = item.countryCode
                                ? item.countryCode.replace(/[^0-9+]/g, "")
                                : "";
                            var phoneForOtpString = item.phoneForOtp
                                ? item.phoneForOtp.replace(/[^0-9+]/g, "")
                                : "";
                            var preferredLanguageString = "Traditional Chinese";
                            if (item.preferredLanguage === "en") {
                                preferredLanguageString = "English";
                            } else if (item.preferredLanguage === "sc") {
                                preferredLanguageString = "Simplified Chinese";
                            }
                            var genderString = "";
                            if (item.gender === "M") {
                                genderString = "Male";
                            } else if (item.gender === "F") {
                                genderString = "Female";
                            } else if (item.gender === "NA") {
                                genderString = "Not specify";
                            }

                            getPatientAttribute(item.linkedcustomertoken);

                            setPatient({
                                name: item.name,
                                linkedCustomerToken: item.linkedcustomertoken,
                                linkedCustomerName: item.linkedcustomer,
                                address: item.description0,
                                gender: genderString,
                                dob: item.dob,
                                contactPerson: item.description1,
                                email: item.email,
                                phone: item.phone,
                                countryCode: String(countryCodeString),
                                phoneForOtp: String(phoneForOtpString),
                                loginEmail: item.username,
                                preferredLanguage: preferredLanguageString,
                                status: statusString,
                                ...additionalAttributes.reduce((acc, field) => {
                                    return { ...acc, [field.dataField]: field.value };
                                }, {}),
                            });
                        });
                    } else {
                        alert(response.data.errmessage);
                    }
                } catch (error) {
                    alert(error);
                }
            };

            fetchData();

        }
    }, [user, fetchTrigger]);


    useEffect(() => {
        if (location.state?.patientToken == null) {
            navigate('/');
        } else {
            const fetchData2 = async () => {
                setLoading(true);
                try {
                    const response = await axios.post(
                        backendlink + 'doctor/getbpdata',
                        {
                            doctortoken: user.userToken,
                            patientToken: location.state.patientToken,
                            duration: selectedDuration,
                        },
                        {
                            headers: {
                                token: user.token,
                            },
                        }
                    );

                    if (response.data.result.errorno == 0) {
                        setBPTable({
                            mean_systolic_blood_pressure: response.data.result.result.mean_systolic_blood_pressure,
                            min_systolic_blood_pressure: response.data.result.result.min_systolic_blood_pressure,
                            max_systolic_blood_pressure: response.data.result.result.max_systolic_blood_pressure,
                            mean_diastolic_blood_pressure: response.data.result.result.mean_diastolic_blood_pressure,
                            min_diastolic_blood_pressure: response.data.result.result.min_diastolic_blood_pressure,
                            max_diastolic_blood_pressure: response.data.result.result.max_diastolic_blood_pressure,
                            mean_pulse: response.data.result.result.mean_pulse,
                            min_pulse: response.data.result.result.min_pulse,
                            max_pulse: response.data.result.result.max_pulse,
                        });

                        setBPPieChart({
                            proportion_condition_1: response.data.result.result.proportion_condition_1,
                            proportion_condition_2: response.data.result.result.proportion_condition_2,
                            proportion_condition_3: response.data.result.result.proportion_condition_3,
                        });

                        setBPGraph(response.data.result.result.datapoints.reverse());
                    }
                    else if (response.data.result.errorno == 40) {
                        setBPTable({
                            mean_systolic_blood_pressure: 0,
                            min_systolic_blood_pressure: 0,
                            max_systolic_blood_pressure: 0,
                            mean_diastolic_blood_pressure: 0,
                            min_diastolic_blood_pressure: 0,
                            max_diastolic_blood_pressure: 0,
                            mean_pulse: 0,
                            min_pulse: 0,
                            max_pulse: 0,
                        });
                        setBPPieChart({
                            proportion_condition_1: 0,
                            proportion_condition_2: 0,
                            proportion_condition_3: 0,
                        });
                        setBPGraph();
                        // notify("Couldn’t retrieve data within the selected duration");
                    }
                    else {
                        console.log(response)

                        alert(response.data.errmessage);
                    }
                } catch (error) {
                    alert(error);
                } finally {
                    setLoading(false);
                }
            };

            fetchData2();
        }
    }, [selectedDuration]);

    useEffect(() => {
        const renderConnectedScatterplot = () => {
            const container = d3.select("#lineChart");

            const width = container.node().getBoundingClientRect().width; // Get the container's width
            const height = 300; // Chart height
            const margin = { top: 20, right: 30, bottom: 30, left: 50 };

            // Clear previous render
            container.selectAll("*").remove();

            const svg = container
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", `translate(${margin.left}, ${margin.top})`);

            // Define scales
            const xScale = d3.scaleLinear()
                .domain([-0.5, BPGraph.length - 0.5]) // Map indices to the x-axis
                .range([0, width - margin.left - margin.right]);

            const yScale = d3.scaleLinear()
                .domain([0, d3.max(BPGraph, d => Math.max(d.systolic_blood_pressure, d.diastolic_blood_pressure))])
                .range([height - margin.top - margin.bottom, 0]);

            // Define axes
            // const xAxis = d3.axisBottom(xScale).tickFormat((d, i) => BPGraph[d]?.record_date || "");
            const xAxis = d3.axisBottom(xScale).tickFormat((d) => {
                if (d >= 0 && d < BPGraph.length && Number.isInteger(d)) {
                    const point = BPGraph[d];
                    return `${point.record_date} ${point.record_time}`; // Combine date and time
                }
                return ""; // Return an empty string for out-of-bounds indices
            });

            const yAxis = d3.axisLeft(yScale);

            // Append axes
            svg.append("g")
            .attr("transform", `translate(0, ${height - margin.top - margin.bottom})`)
            .call(xAxis)
            .selectAll(".tick text")
            .attr("dy", "1.5em") // Add vertical spacing between labels and axis
            .each(function () {
                const text = d3.select(this);
                const lines = text.text().split(" ");
                text.text(null); // Clear existing text
                lines.forEach((line, index) => {
                    text.append("tspan")
                        .attr("x", 0)
                        .attr("dy", index === 0 ? "1em" : "1em") // Adjust vertical position for multi-line labels
                        .text(line);
                });
            });

            svg.append("g")
                .call(yAxis);

            // Define line generators
            const systolicLine = d3.line()
                .x((d, i) => xScale(i)) // Use index for x-axis
                .y(d => yScale(d.systolic_blood_pressure));

            const diastolicLine = d3.line()
                .x((d, i) => xScale(i)) // Use index for x-axis
                .y(d => yScale(d.diastolic_blood_pressure));

            // Append systolic line
            svg.append("path")
                .datum(BPGraph)
                .attr("fill", "none")
                .attr("stroke", "#FF5733")
                .attr("stroke-width", 2)
                .attr("d", systolicLine);

            // Append diastolic line
            svg.append("path")
                .datum(BPGraph)
                .attr("fill", "none")
                .attr("stroke", "#33FF57")
                .attr("stroke-width", 2)
                .attr("d", diastolicLine);

            // Create tooltip
            const tooltip = container
                .append("div")
                .style("position", "absolute")
                .style("background", "#fff")
                .style("border", "1px solid #ddd")
                .style("padding", "5px")
                .style("border-radius", "5px")
                .style("pointer-events", "none")
                .style("display", "none");



            // Append scatterplot points for systolic blood pressure
            svg.selectAll(".systolic-point")
                .data(BPGraph)
                .enter()
                .append("circle")
                .attr("class", "systolic-point")
                .attr("cx", (d, i) => xScale(i)) // Use index for x-axis
                .attr("cy", d => yScale(d.systolic_blood_pressure))
                .attr("r", 4)
                .attr("fill", "#FF5733")
                .on("mouseover", (event, d) => {
                    tooltip.style("display", "block")
                        .html(`Date: ${d.record_date} ${d.record_time}<br>Systolic BP: ${d.systolic_blood_pressure}`);
                })
                .on("mousemove", (event) => {
                    const containerRect = container.node().getBoundingClientRect();
                    const tooltipWidth = tooltip.node().offsetWidth;
                    const tooltipHeight = tooltip.node().offsetHeight;

                    const left = event.clientX - containerRect.left - tooltipWidth / 2;
                    const top = event.clientY - containerRect.top - tooltipHeight - 10;

                    tooltip.style("left", `${left}px`)
                        .style("top", `${top}px`);
                })

                .on("mouseout", () => {
                    tooltip.style("display", "none");
                });

            // Append scatterplot points for diastolic blood pressure
            svg.selectAll(".diastolic-point")
                .data(BPGraph)
                .enter()
                .append("circle")
                .attr("class", "diastolic-point")
                .attr("cx", (d, i) => xScale(i)) // Use index for x-axis
                .attr("cy", d => yScale(d.diastolic_blood_pressure))
                .attr("r", 4)
                .attr("fill", "#33FF57")
                .on("mouseover", (event, d) => {
                    tooltip.style("display", "block")
                        .html(`Date: ${d.record_date} ${d.record_time}<br>Diastolic BP: ${d.diastolic_blood_pressure}`);
                })
                .on("mousemove", (event) => {
                    const containerRect = container.node().getBoundingClientRect();
                    const tooltipWidth = tooltip.node().offsetWidth;
                    const tooltipHeight = tooltip.node().offsetHeight;

                    const left = event.clientX - containerRect.left - tooltipWidth / 2;
                    const top = event.clientY - containerRect.top - tooltipHeight - 10;

                    tooltip.style("left", `${left}px`)
                        .style("top", `${top}px`);
                })

                .on("mouseout", () => {
                    tooltip.style("display", "none");
                });

            // Add labels
            svg.append("text")
                .attr("x", width / 2)
                .attr("y", height - margin.bottom + 20)
                .style("text-anchor", "middle")
                .text("Date");

            svg.append("text")
                .attr("transform", "rotate(-90)")
                .attr("x", -height / 2)
                .attr("y", -margin.left + 15)
                .style("text-anchor", "middle")
                .text("Blood Pressure (mmHg)");
        };

        if (BPGraph?.length > 0) {
            renderConnectedScatterplot();
        }
    }, [BPGraph]);

    useEffect(() => {
        const renderPieChart = (chartId, proportion, color) => {
            const width = 150;
            const height = 150;
            const radius = Math.min(width, height) / 2;

            const svg = d3.select(`#${chartId}`)
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", `translate(${width / 2}, ${height / 2})`);

            const pie = d3.pie().value(d => d.value);
            const data = [
                { value: proportion, color: color },
                { value: 100 - proportion, color: "#CCCCCC" }
            ];

            const arc = d3.arc()
                .innerRadius(radius * 0.6) // Donut hole size
                .outerRadius(radius);

            svg.selectAll("path")
                .data(pie(data))
                .enter()
                .append("path")
                .attr("d", arc)
                .attr("fill", d => d.data.color);
        };

        // Render the three pie charts
        d3.select("#donutChart1").selectAll("*").remove(); // Clear previous render
        renderPieChart("donutChart1", BPPieChart.proportion_condition_1, "#FF5733");

        d3.select("#donutChart2").selectAll("*").remove(); // Clear previous render
        renderPieChart("donutChart2", BPPieChart.proportion_condition_2, "#FF5733");

        d3.select("#donutChart3").selectAll("*").remove(); // Clear previous render
        renderPieChart("donutChart3", BPPieChart.proportion_condition_3, "#FF5733");
    }, [BPPieChart]);

    const readonlyptions = { readOnly: 'true' };

    return (
        <div className="card-container" style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>

            {/* Patient Information Card */}
            <div className="card" style={{ flex: "1 1 45%" }}>
                <h2>Patient Information</h2>
                <div className="user-info">
                    <div className="user-info-item">
                        <span className="label">Patient Name:</span>
                        <span className="value">{patient.name}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Linked Organization:</span>
                        <span className="value">{patient.linkedCustomerName}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Address:</span>
                        <span className="value">{patient.address}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Gender:</span>
                        <span className="value">{patient.gender}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Date of Birth:</span>
                        <span className="value">{patient.dob}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Preferred Language:</span>
                        <span className="value">{patient.preferredLanguage}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Status:</span>
                        <span className="value">{patient.status}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Login Phone Number:</span>
                        <span className="value">{patient.phoneForOtp ? `+${patient.countryCode}-${patient.phoneForOtp}` : 'NA'}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Login Email:</span>
                        <span className="value">{patient.loginEmail}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Contact Person:</span>
                        <span className="value">{patient.contactPerson}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Contact Number:</span>
                        <span className="value">{patient.phone}</span>
                    </div>
                    <div className="user-info-item">
                        <span className="label">Contact Email:</span>
                        <span className="value">{patient.email}</span>
                    </div>

                    {additionalAttributes.map((attribute) => (
                        attribute.value && (
                            <div key={attribute.dataField} className="user-info-item">
                                <span className="label">{attribute.label}:</span>
                                <span dangerouslySetInnerHTML={{ __html: attribute.value?.replace(/\n/g, "<br />") }} />
                            </div>
                        )
                    ))}
                    {/* Add more fields as needed */}
                </div>
            </div>

            {/* Blood Pressure Summary Card */}
            <div className="card" style={{ flex: "1 1 45%" }}>
                <h2>Blood Pressure Summary</h2>
                {/* Duration Select Box */}
                <div style={{ width: "100%", marginBottom: "20px" }}>
                    <label htmlFor="duration-select" style={{ marginRight: "10px" }}>Select Duration:</label>
                    <select id="duration-select" value={selectedDuration} onChange={handleDurationChange}>
                        <option value="0">1 Week</option>
                        <option value="1">1 Month</option>
                        <option value="2">3 Months</option>
                        <option value="3">6 Months</option>
                        <option value="4">1 Year</option>
                    </select>
                </div>
                {loading && (
                    <div className="loading-overlay"
                        style={{
                            display: "flex", // Use Flexbox
                            justifyContent: "center", // Center horizontally
                            alignItems: "center", // Center vertically
                        }}>
                        <LoadIndicator visible={true} width={50} height={50} />
                    </div>
                )}
                {!loading && !BPGraph && (
                    <div className="loading-overlay"
                        style={{
                            display: "flex", // Use Flexbox
                            justifyContent: "center", // Center horizontally
                            alignItems: "center", // Center vertically
                        }}>
                        <p>Couldn’t retrieve data within the selected duration</p>
                    </div>
                )}
                {!loading && BPGraph &&
                    <div className="summary-row" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        {/* First row: Table */}
                        <div style={{ width: "100%" }}>
                            <table className="blood-pressure-table" style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}></th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Systolic Blood Pressure (mmHg)</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Diastolic Blood Pressure (mmHg)</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Pulse (BPM)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>Max</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.max_systolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.max_diastolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.max_pulse}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>Min</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.min_systolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.min_diastolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.min_pulse}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>Average</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.mean_systolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.mean_diastolic_blood_pressure}</td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px" }}>{BPTable.mean_pulse}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* Second row: Donut charts */}
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", alignContent: "center" }}>
                                <div className='donuttitle'>
                                    Systolic Blood Pressure &lt;130mmHg <br /> and <br /> diastolic blood pressure &lt;80mmHg
                                </div>
                                <div id="donutChart1" style={{ width: "150px", height: "150px" }}></div>
                                <div className='donutpercentage'>
                                    {BPPieChart.proportion_condition_1} %
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div className='donuttitle'>
                                    Systolic Blood Pressure &lt;140mmHg <br /> and <br /> diastolic blood pressure &lt;90mmHg
                                </div>
                                <div id="donutChart2" style={{ width: "150px", height: "150px" }}></div>
                                <div className='donutpercentage'>
                                    {BPPieChart.proportion_condition_2} %
                                </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div className='donuttitle'>
                                    Systolic Blood Pressure &gt;=160mmHg <br /> and <br /> diastolic blood pressure &gt;=100mmHg
                                </div>
                                <div id="donutChart3" style={{ width: "150px", height: "150px" }}></div>
                                <div className='donutpercentage'>
                                    {BPPieChart.proportion_condition_3} %
                                </div>
                            </div>
                        </div>
                        {/* Third row: Line chart */}
                        <div id="lineChart" style={{ position: "relative", width: "100%", height: "300px", marginTop: "20px" }}></div>
                    </div>
                }
            </div>
        </div>

    )
}